export const RETAILER_RECEIVE_SHARINGUNITS = 'RETAILER_RECEIVE_SHARINGUNITS';
export const RETAILER_UPDATE_SINGLE_SHARINGUNIT =
  'RETAILER_UPDATE_SINGLE_SHARINGUNIT';
export const RETAILER_RESET_SHARINGUNITS = 'RETAILER_RESET_SHARINGUNITS';
